import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ReactPlayer from 'react-player';

/**
 * Conversation message video player component that provides shared video functionality
 * for different video message types (Instagram direct, Instagram comments, etc.)
 */
export default function ConversationMessageVideoPlayer({
  url,
  onError,
  onHeightChange,
  playButtonComponent,
  videoPlayerComponent: VideoPlayerComponent = ReactPlayer,
  containerProps = {},
  videoPlayerProps = {},
}) {
  const [isPlaying, setIsPlaying] = useState(false);

  const handleVideoClick = () => {
    setIsPlaying(!isPlaying);
  };

  return (
    <div {...containerProps}>
      {!isPlaying && playButtonComponent}
      <VideoPlayerComponent
        config={{
          file: {
            attributes: {
              controlsList: 'nodownload',
              disablePictureInPicture: true,
            },
          },
        }}
        controls={isPlaying}
        height="auto"
        loop
        muted
        onClick={handleVideoClick}
        onError={onError}
        onPause={() => setIsPlaying(false)}
        onPlay={() => setIsPlaying(true)}
        onReady={onHeightChange}
        url={url}
        volume={0.25}
        width="100%"
        {...videoPlayerProps}
      />
    </div>
  );
}

ConversationMessageVideoPlayer.propTypes = {
  url: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onHeightChange: PropTypes.func,
  playButtonComponent: PropTypes.node,
  videoPlayerComponent: PropTypes.elementType,
  containerProps: PropTypes.object,
  videoPlayerProps: PropTypes.object,
};
